var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-div",style:({height: _vm.now_height})},[_c('img',{staticClass:"collapse-img collapse-icon",class:{ 'closed': _vm.type=='closed' },attrs:{"src":require("../../assets/img/open.png")},on:{"click":function($event){return _vm.clickImg()}}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d24d036","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XrCollapse/index.vue
// module id = null
// module chunks = 